
  import { defineComponent, ref, toRefs, watch } from 'vue';

  import { Cascader, Popup } from 'vant';
  import 'vant/es/popup/style';
  import 'vant/es/cascader/style';
  import { CascaderOptions, CascaderOptionsItem } from '../typings';

  export default defineComponent({
    name: 'BaseCascader',
    components: {
      Cascader,
      Popup,
    },
    props: {
      modelValue: {
        type: Array as PropType<string[]>,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: () => false,
      },
      options: {
        type: Array as PropType<CascaderOptions>,
        default: () => [],
      },
      placeholder: {
        type: String,
        default: () => '',
      },
    },
    emits: ['change', 'update:modelValue'],
    setup(props, { emit }) {
      const selectText = ref('');
      const show = ref(false);
      const { options, modelValue } = toRefs(props);
      const cascaderValue = ref('');

      function showPopup() {
        show.value = true;
      }

      function onFinish({ selectedOptions }) {
        show.value = false;
        selectText.value = selectedOptions.map((option) => option.text).join('/');
        const arr = selectedOptions.map((option) => option.value);
        emit('update:modelValue', arr);
      }

      watch([options, modelValue], () => {
        initSelectText();
      });

      function initSelectText() {
        if (Array.isArray(modelValue.value) && modelValue.value.length) {
          selectText.value = formatText(modelValue.value, options.value);
          cascaderValue.value = modelValue.value[modelValue.value.length - 1];
        }
      }

      function formatText(modelValue: string[], tree: CascaderOptions) {
        const result: string[] = [];
        const loop = (values: string[], list: CascaderOptions, index = 0) => {
          if (values[index]) {
            const value = values[index];
            const obj = list.find((e) => e.value == value) as CascaderOptionsItem;
            if (obj) {
              result.push(obj.text);
              if (obj.children) {
                loop(values, obj.children, index + 1);
              }
            }
          }
        };
        loop(modelValue, tree);
        return result.join('/');
      }
      function onChange(e) {
        emit('change', e);
      }

      initSelectText();

      return {
        showPopup,
        show,
        selectText,
        cascaderValue,
        onFinish,
        onChange,
      };
    },
  });
